// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// https://switcheroo.atlassian.com/ui/gates/714d36e0-d971-4221-9888-23c4682396aa/key/townsquare_remove_apps_from_fyp
// Poster: https://hello.atlassian.net/wiki/spaces/STATUS/pages/6402034501/Experiment+plan+Remove+Your+apps+from+Home+s+For+you+page
export const REMOVE_APPS_FROM_FYP_EXPERIMENT = 'townsquare_remove_apps_from_fyp';

// Verified teams in for you experiment - exposure only fires when recommendedTeams query has results
export const VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT = 'verified_teams_in_for_you';

// Teams recommendations for you experiment - exposure only fires when rovo teams recommendations are cached.
export const TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT = 'recommended_teams_in_for_you_page';

export const USER_PROFILE_REFRESH_EXPERIMENT = 'user_profile_refresh_experiment';

// https://switcheroo.atlassian.com/ui/gates/048576dc-2aa1-48c4-b958-33de9d609284/key/navx_uc_trello_in_home
export const NAVX_UC_TRELLO_IN_HOME_EXPERIMENT = 'navx_uc_trello_in_home';

// https://switcheroo.atlassian.com/ui/gates/5df9f216-7f3c-4f54-a2c7-67873439d0ac/key/jira-space-invite-teams-app
export const JIRA_SPACE_INVITE_TEAMS_APP = 'jira-space-invite-teams-app';

// https://switcheroo.atlassian.com/ui/gates/0eaf07c6-7ed3-4de3-85e0-aedf283b46ab/key/navx_uc_gic_in_home
export const NAVX_UC_GIC_IN_HOME_EXPERIMENT = 'navx_uc_gic_in_home';

// https://switcheroo.atlassian.com/ui/gates/85224d4a-d165-4b50-afca-6d082ff55426/key/townsquare_enable_chat_header
export const TOWNSQUARE_ENABLE_CHAT_HEADER_EXPERIMENT = 'townsquare_enable_chat_header';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
	REMOVE_APPS_FROM_FYP_EXPERIMENT,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT,
	TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT,
	USER_PROFILE_REFRESH_EXPERIMENT,
	NAVX_UC_TRELLO_IN_HOME_EXPERIMENT,
	TOWNSQUARE_ENABLE_CHAT_HEADER_EXPERIMENT,
	JIRA_SPACE_INVITE_TEAMS_APP,
	NAVX_UC_GIC_IN_HOME_EXPERIMENT,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
